import Form from "views/Form";
import className from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import { formConfig } from "pages/Trunks/NewTrunk/formConfig";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useEffect, useLayoutEffect, useState } from "react";
import FormElement from "components/Form/FormElement/FormElement";
import { useCreateTrunkMutation } from "features/trunk/trunkApiSlice";
import FormDropdown from "components/Form/FormDropdown/FormDropdown";
import { searchHandler } from "models/search";
import { selectAllResults } from "features/search/searchSlice";
import { dropdownItemSelector } from "models/form";
import { toast } from "react-hot-toast";
import { parseError } from "utils/helpers";

import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const form = new Form(formConfig);

const NewTrunk = () => {
  const [activeInput, setActiveInput] = useState("");

  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const searchResults = useSelector(selectAllResults);

  const [createTrunk, { isLoading }] = useCreateTrunkMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("New Trunk"));
  }, [dispatch]);

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear(); // will run once in production
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    const formData = {};

    if (formValidity) {
      for (const key in form.getFormConfig()) {
        const el = form.getFormConfig()[key];

        if (key.split("_")[1] === "id") {
          formData[key] = el.elementConfig["data-id"];
        } else {
          formData[key] = el.elementConfig.value;
        }
      }

      try {
        await createTrunk(formData).unwrap();
        toast.success("Trunk created successfully");
        navigate({
          pathhname: "/trunks",
          search: createSearchParams({ page: "1" }).toString(),
        });
      } catch (error) {
        const errorMessage = parseError(error);
        toast.error(errorMessage);
      }
    }
  };

  const dropdownItemClickHandler = (key, item) => {
    dropdownItemSelector(key, item, form);
    setFormElements(form.formElements);

    setActiveInput("");
  };

  const inputChangeHandler = (e) => {
    const updatedInput = form.inputChangeHandler(e);

    setActiveInput(e.target.id);

    if (updatedInput) {
      if (e.target.id === "gateway_id") {
        searchHandler("/gateways", e.target.value, dispatch);
      }

      if (e.target.id === "provider_id") {
      }

      form.updateFormElement({ id: e.target.id, config: updatedInput });

      form.checkFormValidity();

      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  };

  return (
    <div
      className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}
    >
      <div
        className={className({
          [cardStyles.menu]: true,
          [utilityStyles.wFull]: true,
        })}
      >
        <h3>Fill in details for the new Trunk</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;

            return (
              <div key={`el-group-${idx + 1}`} className={formStyles.group}>
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
                <FormDropdown
                  items={searchResults}
                  itemClickHandler={(item) =>
                    dropdownItemClickHandler(elementConfig.id, item)
                  }
                  visible={
                    activeInput === elementConfig.id && el.config.dropdown
                  }
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <button disabled={isLoading || !formValidity}>
              {isLoading ? "Creating trunk..." : "Create Trunk"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewTrunk;
